import Profile from "./profile.vue";
export default Profile;
